import { convertToUserTimezone } from "./convertToUserTimezone";

export function formatAgendaDate(
  startDate?: string,
  endDate?: string | null,
  startTime?: string | null,
  endTime?: string | null,
  t?: (key: string) => string,
): string {
  if (!startDate) return "";

  const extractTime = (originalDate?: string | null | undefined, dateStr?: string | null | undefined) => {
    if (!originalDate) return "";

    const time = dateStr ? dateStr : originalDate.split("T")[1].slice(0, 5);
    const convertedDateTime = convertToUserTimezone(originalDate.split("T")[0] + "T" + time + ":00Z");

    return convertedDateTime;
  };

  const userStartDate = extractTime(startDate, startTime);
  const userEndDate = extractTime(endDate, endTime);

  const thisStartDateTime = new Date(userStartDate);
  const thisEndDateTime = userEndDate ? new Date(userEndDate) : null;
  // Formating to HH:mm
  const fillNumberZeros = (thisNumber: number) => thisNumber.toString().padStart(2, "0");
  const now = new Date();
  const _startDate = thisStartDateTime.getUTCDate();
  const _startMonth = thisStartDateTime.getUTCMonth();
  const _startYear = thisStartDateTime.getUTCFullYear();
  const _startHours = thisStartDateTime.getUTCHours();
  const _startMinutes = thisStartDateTime.getUTCMinutes();

  let _endTime = "";
  // Set end time based on whether userEndDate is provided
  if (thisEndDateTime) {
    const _endHours = thisEndDateTime.getUTCHours();
    const _endMinutes = thisEndDateTime.getUTCMinutes();

    _endTime = `${fillNumberZeros(_endHours)}:${fillNumberZeros(_endMinutes)}`;
  } else {
    // Add 1 hour if no userEndDate
    _endTime = `${fillNumberZeros(_startHours + 1)}:${fillNumberZeros(_startMinutes)}`;
  }

  const isToday = _startDate === now.getUTCDate() && _startMonth === now.getUTCMonth() && _startYear === now.getUTCFullYear();

  const _startTime = `${fillNumberZeros(_startHours)}:${fillNumberZeros(_startMinutes)}`;

  if (isToday) {
    return `${t ? t("todayLabel") : "Today"}, ${_startTime} - ${_endTime}`;
  } else {
    return `${fillNumberZeros(_startDate)}/${fillNumberZeros(_startMonth + 1)}/${_startYear}, ${_startTime} - ${_endTime}`;
  }
}
